import { configureStore } from "@reduxjs/toolkit";
import commonSlice from "@src/common/commonSlice";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

const store = configureStore({
  reducer: {
    common: commonSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Use useAppDispatch and useAppSelector instead of plain useDispatch and
// useSelector
// See: https://redux-toolkit.js.org/tutorials/typescript
// or somethingf
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
